import { styled } from "sharedUI/styles";

export const Container = styled.div`
    background-color: #565763;
    height: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Title = styled.div`
    color: #FFF;
    font-size: 16px;
    line-height: 26px;
    margin-top: 10px;
    text-align: center;
`;

export const SubTitle = styled.div`
    color: #FFF;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 10px;
    text-align: center;
`
